import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'
import img61 from '../EquipoMedico/img61.jpg'
import img62 from '../EquipoMedico/img62.jpg'

export class Emergency extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Emergency</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Usamos Row con Col md={6} para que las dos fotos tengan buen tamaño 
                        y la información densa sea legible */}
                    <Row className="justify-content-center g-4">
                        <Col xs={12} lg={6}>
                            <Card className="shadow border-0 text-center h-100">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img61} 
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.5rem' }}>Emergency Room Equipment I</Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>

                        <Col xs={12} lg={6}>
                            <Card className="shadow border-0 text-center h-100">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img62} 
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.5rem' }}>Emergency Room Equipment II</Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}